import React, { useState, useCallback } from 'react';

import { W } from '../i18n';
import PolicyAndServicePopup from '../PolicyAndServicePopup/PolicyAndServicePopup';

import './Footer.global.styl';

function Footer() {
  const [showPop, setShowPop] = useState(false);
  const [currentTab, setCurrentTab] = useState<'policy' | 'service'>('policy');

  const handleClosePopup = useCallback(() => {
    setShowPop(false);
  }, []);

  const handleChangeCurrentTab = useCallback(tab => {
    setCurrentTab(tab);
    setShowPop(true);
  }, []);

  const date = new Date();
  const year = date.getFullYear();

  return (
    <div className="mio-footer">
      <div
        className="mio-footer__button"
        onClick={() => handleChangeCurrentTab('service')}
      >
        Terms of Service
      </div>

      <div
        className="mio-footer__button"
        onClick={() => handleChangeCurrentTab('policy')}
      >
        Privacy Policy
      </div>

      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${window.__config__.landingPageUrl}/en-US/contact-us`}
        className="mio-footer__button"
      >
        Contact us
      </a>

      <div className="mio-footer__copy-line">
        &copy;2016-{year} {W('shared.footer.miotech', null, 'MioTech')}.{' '}
        {W('shared.footer.allRightsReserved', null, 'All rights reserved.')}
      </div>

      <PolicyAndServicePopup
        currentTab={currentTab}
        visible={showPop}
        onClose={handleClosePopup}
        onChangeTab={handleChangeCurrentTab}
      />
    </div>
  );
}

export default Footer;
